import { Class } from 'generated/graphql';
import { z } from 'zod';

export const schema = z.object({
  name: z.string().min(3).max(255),
  description: z
    .string()
    .min(3, { message: 'Enter at least 3 characters' })
    .max(500, 'Enter max 500 characters'),
  type: z.string(),
  color: z
    .string()
    .regex(/^#[a-zA-Z0-9]{6}/)
    .nullable(),
  date: z.string(),
  time: z.string(),
  duration: z
    .string()
    .min(1, { message: 'Enter at least 1 digit' })
    .max(5, { message: 'Enter max 5 digits' }),
  cover: z.object({
    cdn01: z.string(),
    image: z.string(),
  }),
  difficulty: z.string(),
  location: z
    .array(z.string())
    .min(1, { message: 'Please select at least 1 location' }),
  category: z.array(z.string()),
});

export type IForm = Required<z.infer<typeof schema>>;

export type AugmentedClass = Class & {
  dtstart: Date;
  isUpcoming: boolean;
};
